/* Dithya – free gift guard.
   Keeps at most ONE "Free Gift – Dithya's Choice" in the cart.
   If a second gift line appears (e.g. after a failed payment and retry), the extra one is removed.
   The line Breeze marked as its reward (_breeze_gift) is the one kept. Nothing else in the cart is touched. */
(function () {
  var GIFT_VARIANT = 67854680817842;
  var busy = false, timer = null;
  var nativeFetch = window.fetch;
  if (!nativeFetch) return;

  function check() {
    if (busy) return;
    busy = true;
    nativeFetch.call(window, '/cart.js', { cache: 'no-store', credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var gifts = (cart.items || []).filter(function (it) { return it.variant_id === GIFT_VARIANT; });
        var total = gifts.reduce(function (s, it) { return s + it.quantity; }, 0);
        if (total <= 1) return;
        var keep = gifts.filter(function (it) { return it.properties && it.properties._breeze_gift; })[0] || gifts[gifts.length - 1];
        var updates = {};
        gifts.forEach(function (it) { updates[it.key] = (it.key === keep.key) ? 1 : 0; });
        return nativeFetch.call(window, '/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function () {
          try { document.dispatchEvent(new CustomEvent('dithya:gift-deduped')); } catch (e) {}
        });
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  function soon() { clearTimeout(timer); timer = setTimeout(check, 700); }

  // Re-check whenever the cart changes (Breeze and theme both use the Shopify cart API).
  window.fetch = function (input, init) {
    var url = '';
    try { url = typeof input === 'string' ? input : (input && input.url) || ''; } catch (e) {}
    var p = nativeFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)(\.js)?/.test(url)) { p.then(soon, soon); }
    return p;
  };
  var open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) {
    if (/\/cart\/(add|change|update)(\.js)?/.test(String(url))) { this.addEventListener('loadend', soon); }
    return open.apply(this, arguments);
  };

  // Check on page load and when the customer comes back to the tab (e.g. after a failed payment).
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', soon); } else { soon(); }
  document.addEventListener('visibilitychange', function () { if (!document.hidden) soon(); });
  window.addEventListener('pageshow', soon);
})();
